<script>
// Linha do seletor de etiquetas: cor, nome e descrição, com o estado marcado à direita.
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    selected: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['selectLabel'],

  methods: {
    onClick() {
      this.$emit('selectLabel', this.title);
    },
  },
};
</script>

<template>
  <button
    type="button"
    role="option"
    :aria-selected="selected"
    :title="description || title"
    class="group flex w-full items-center gap-2.5 rounded-lg px-2 py-1.5 text-left transition-colors"
    :class="[
      active ? 'bg-n-alpha-2' : 'hover:bg-n-alpha-1',
      selected ? 'text-n-slate-12' : 'text-n-slate-11',
    ]"
    data-testid="label-dropdown-item"
    @click="onClick"
  >
    <span
      class="grid size-6 shrink-0 place-items-center rounded-md"
      :style="
        color
          ? {
              backgroundColor: `color-mix(in srgb, ${color} 14%, transparent)`,
            }
          : undefined
      "
      aria-hidden="true"
    >
      <span
        class="size-2.5 rounded-full"
        :class="{ 'bg-n-slate-9': !color }"
        :style="color ? { backgroundColor: color } : undefined"
      />
    </span>
    <span class="min-w-0 flex-1">
      <span
        class="block truncate text-sm leading-5"
        :class="selected ? 'font-semibold' : 'font-medium'"
      >
        {{ title }}
      </span>
      <span
        v-if="description"
        class="block truncate text-xs leading-4 text-n-slate-10"
      >
        {{ description }}
      </span>
    </span>
    <span
      class="grid size-5 shrink-0 place-items-center rounded-full border transition-colors"
      :class="
        selected
          ? 'border-n-brand bg-n-brand text-white'
          : 'border-n-weak text-transparent group-hover:border-n-strong'
      "
      aria-hidden="true"
    >
      <span class="i-hugeicons-tick-02 size-3" />
    </span>
  </button>
</template>
